import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITargetedReconciliationRecord, ITargetedReconciliationResponse } from "@/services/targetedReconciliation/types";

export interface TargetedReconciliationState {
  targetedReconciliation: ITargetedReconciliationResponse;
  loading: boolean;
  error: boolean;
  message?: string;
}

const initialState: TargetedReconciliationState = {
  targetedReconciliation: {
    success: false,
    message: "",
    data: [],
    pagination: {
      totalRecords: 0,
      currentPage: 0,
      totalPages: 0,
      nextPage: 0,
      currentLimit: 0,
    },
  },
  loading: false,
  error: false,
  message: "",
};

const targetedReconciliationSlice = createSlice({
  name: "targetedReconciliation",
  initialState,
  reducers: {
    fetchTargetedReconciliationRecords: (state, action: PayloadAction<any>) => {
      state.loading = true;
      state.error = false;
      state.message = "";
    },
    fetchTargetedReconciliationSuccess: (state, action: PayloadAction<ITargetedReconciliationResponse>) => {
      state.loading = false;
      state.error = false;
      state.targetedReconciliation = { ...action.payload };
      state.message = action.payload.message;
    },
    fetchTargetedReconciliationFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = true;
      state.message = action.payload;
      state.targetedReconciliation = { ...initialState.targetedReconciliation };
    },
    clearTargetedReconciliationError: (state) => {
      state.error = false;
      state.message = "";
    },
  },
});

export const {
  fetchTargetedReconciliationRecords,
  fetchTargetedReconciliationSuccess,
  fetchTargetedReconciliationFailure,
  clearTargetedReconciliationError,
} = targetedReconciliationSlice.actions;

export default targetedReconciliationSlice.reducer;
